import useProtoMethod from "./useProtoMethod";
import {
  RunWorkflowRequest,
  RunWorkflowResponse,
} from "protogen/workflow_service_pb";
import { getInferenceDomain } from "../constants";

const useRunWorkflow = (callback?: (r: RunWorkflowResponse) => void) => {
  return useProtoMethod<RunWorkflowRequest, RunWorkflowResponse>(
    "RunWorkflow",
    RunWorkflowResponse,
    {
      callback,
      baseUrl: getInferenceDomain(),
    },
  );
};

export { useRunWorkflow };
